import { getAuthHeader, refreshAccessToken } from '../auth'

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8001'
export const API_BASE = `${API_URL}/api`

export function createHeaders(additionalHeaders: Record<string, string> = {}): Record<string, string> {
  return {
    ...getAuthHeader(),
    ...additionalHeaders
  }
}

/**
 * Fetch wrapper that injects auth headers and handles 401 responses by
 * attempting a token refresh and retrying the request once. If the refresh
 * fails, the user is logged out (handled inside refreshAccessToken).
 */
export async function authenticatedFetch(
  url: RequestInfo | URL,
  options: RequestInit = {}
): Promise<Response> {
  const optionsWithAuth: RequestInit = {
    ...options,
    headers: {
      ...createHeaders(),
      ...(options.headers as Record<string, string> | undefined),
    },
  }

  const response = await fetch(url, optionsWithAuth)

  if (response.status === 401) {
    const refreshed = await refreshAccessToken()
    if (!refreshed) {
      throw new Error('Unauthorized')
    }
    // Retry with fresh token
    const retryOptions: RequestInit = {
      ...options,
      headers: {
        ...createHeaders(),
        ...(options.headers as Record<string, string> | undefined),
      },
    }
    return fetch(url, retryOptions)
  }

  return response
}
